import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { L10nService } from '@nano/core/l10n';

import { Classifier, ClassifierService, GlossaryId } from '@nano/common/classifier';

@Injectable({
  providedIn: 'root'
})
export class ServiceChargeDetailsService {
  readonly serviceChargeDetails$: Observable<Classifier[]>;

  constructor(
    private classifierService: ClassifierService,
    private l10nService: L10nService
  ) {
    this.serviceChargeDetails$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getGlossary(GlossaryId.SERVICE_CHARGE_DETAILS)),
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }
}
